module.exports = __webpack_public_path__ + "static/media/slide-2r.5229e4b8.jpg";